import { useMemo } from "react"

export function useEmptyImage() {
  return useMemo(() => {
    const result = new Image()
    result.src =
      "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
    return result
  }, [])
}
